<script>
  import * as firebaseui from "firebaseui";
  import firebase from "firebase/app";
  import { onMount, tick } from "svelte";
	import {fade, fly} from 'svelte/transition'

	import {currentUser, filesToAdd, userInfo, loadingImages} from './store'

	import UserObserver from './UserObserver.svelte'
	import Logo from "./Logo.svelte";
	import Btn from "./Btn.svelte";
	import How from "./How.svelte";
	import Modal from './Modal.svelte'
	import Detail from './Detail.svelte'
	import Sub from "./Sub.svelte";

	import "@firebase/firestore"
	import "@firebase/storage"
	import Uploader from "./Uploader.svelte";
import BottomCard from "./BottomCard.svelte";

	let how = false, showSubError = false

	let signin = true, show, showAddModal, submissions = [], itemModal

  const firebaseConfig = {
    apiKey: "AIzaSyCbVmEsNG5JuXXmYMTXjYZA96H3Y5CBJfY",
    authDomain: "budtools.firebaseapp.com",
    projectId: "budtools",
    storageBucket: "budtools.appspot.com",
    messagingSenderId: "740444292134",
    appId: "1:740444292134:web:dc67414793aabb851052e7",
  };

  firebase.initializeApp(firebaseConfig);

	let db = firebase.firestore();

	const storageRef = firebase.storage().ref()

  function createAll() {
    var uiConfig = {
      signInOptions: [
				{
					provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
					fullLabel: `Connect with Google`
				},
				{
					provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
					fullLabel: `Connect with Facebook`
				},
				// {
				// 	provider: firebase.auth.TwitterAuthProvider.PROVIDER_ID,
				// 	fullLabel: `Connect with Twitter`
				// },
      ],
			callbacks: {
				signInSuccessWithAuthResult: function(authResult, redirectUrl) {
					// We return false to prevent redirect
					return false
				}
			},
      // tosUrl and privacyPolicyUrl accept either url string or a callback function.
      tosUrl: "https://healthybud.co/terms",
      // Privacy policy url/callback.
      privacyPolicyUrl: function () {
        window.location.assign("https://healthybud.co/privacy");
      },
    };

    // Initialize the FirebaseUI Widget using Firebase.
    var ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
    // The start method will wait until the DOM is loaded.
    ui.start("#firebaseui-auth-container", uiConfig);
  }

	function signOut() {
		firebase.auth().signOut().then(async function() {
			await tick()
			createAll()
		}).catch(error => {
			alert(error)
		})
	}

	function getPosts() {
		submissions = []
		db.collection("submissions").where("user", "==", $userInfo.id).get()
		.then((querySnapshot) => {
			if (querySnapshot.docs.length > 0) {
				showSubError = false
				querySnapshot.forEach((doc) => {
					submissions = [...submissions, {...doc.data(), docid: doc.id}]
				})
				$userInfo.submissions = submissions
			} else {
				showSubError = true
			}
		})
		.catch((error) => {
			console.error(error)
		})
	}

	function addSubmission(item) {
		subObject.contents = $filesToAdd
    db.collection("submissions").add(
      {
				email: $userInfo.email,
				name: $userInfo.name,
				user: $userInfo.id,
				igHandle: $userInfo.instagram,
				livePostUrl: '',
				message: '',
        ...subObject
      }
    ).then(()=> {
			
			showSubError = false
			getPosts()
    }).catch((error)=> {
      console.log('Something went wrong')
    })
  }


	function submit() {
		$userInfo.submissions = [...$userInfo.submissions, subObject]
		addSubmission($userInfo)
		showAddModal = false
		step = 1
		subObject = subObjectReset
		$filesToAdd = []
	}

	function closeModal() {
		$filesToAdd = []
		step = 1
		showAddModal = false;
		subObject = subObjectReset;
	}

	function getDate() {
		const now = new Date()
		const m = now.getMonth() + 1
		const d = now.getDate()
		const y = now.getFullYear()
		return `${m}/${d}/${y}`
	}

	async function toggle() {
		if (how) {
			how = false
			await tick()
			createAll();
		} else {
			how = true
		}
	}

	let step = 1

	let subObjectReset = {
		title: '',
		caption: '',
		contents: [],
		status: 'submitted',
		date: getDate()
	}

	let subObject = {
		title: '',
		caption: '',
		contents: $filesToAdd,
		status: 'submitted',
		date: getDate()
	}

	let postsLoaded = false
	function getPostsOnce() {
		if (postsLoaded) {
			return
		} else {
			getPosts()
		}
		postsLoaded = true
	}

	$: if ($userInfo) getPostsOnce()

	// Someday I will make this work too
	//
	// function deleteFile(item) {
	// 	const fileRef = storageRef.child(item)

	// 	fileRef.delete().then(() => {
	// 		console.log('File deleted from storage')
	// 	}).catch((error) => {
	// 		console.error('File not deleted', error)
	// 	})
	// }

	function deleteSubmission(item) {
		db.collection("submissions")
			.doc(item.docid)
			.delete().then(() => {
				getPosts()
				itemModal = null
			}).catch((error) => {
				alert('Something went wrong, please try again.')
			})
	}

	function closeItemModal() {
		itemModal = null
	}

  onMount(() => {
		createAll()
		show = true
  });
</script>
<UserObserver />


<main>
	{#if showAddModal}
		<Modal on:close={closeModal} on:back={()=> step --} {step}>
			{#if step == 1}
				<h2>Step 1: Upload your content</h2>
				<Uploader />
			{:else if step == 2}
				<!-- Title and caption -->
				<h2>Step 2: Add some info</h2>
				<label for="">
					Your Instagram handle
					<input bind:value={$userInfo.instagram} />
				</label>
				<label for="">
					Title (for your reference)
					<input bind:value={subObject.title} />
				</label>
				<label>
					Caption it!
					<textarea bind:value={subObject.caption} />
				</label>
			{:else}
				<!-- Submit and close -->
				<h2>Step 3: Submit</h2>
				<Btn on:click={submit}>Submit</Btn>
			{/if}
		</Modal>
	{/if}

	<header>
		<div>
			<Logo />
			<p class="logo-add">Feature My Bud</p>
		</div>
		{#if show}
			{#if $currentUser}
			<div in:fade={{ delay: 500 }} >
				<Btn small warn on:click={signOut}>Logout</Btn>
			</div>
			{:else}
			<div in:fade={{ delay: 500 }}>
				<Btn small on:click={toggle}>{how? 'Get started' : 'How it works'}</Btn>
			</div>
			{/if}
		{/if}
	</header>

	<!-- Must wrap all calls to userInfo in this or pay the price
	{#if $userInfo} <- You need this
		{$userInfo.email} <- You're safe to call it here
	{/if}
	-->
	<div class="page-content">
		{#if $currentUser}
			<div in:fly={{ y: 20 }}>
				<Btn secondary icon  on:click={()=> showAddModal = true}>
					<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
					New Post
				</Btn>
			</div>
		{/if}
		<div class="footer">
			{#if $currentUser}
				{#if $userInfo}
					<h2 in:fly={{ y: 20 }}>My submissions - {submissions.length}</h2>
					<div class="submissions">
						{#key submissions}
							{#each submissions as sub, index}
								{#if itemModal == index}
									<Modal on:click={()=> itemModal = null} on:close={closeItemModal} on:delete={()=> deleteSubmission(sub)} status={sub.status} detail>
										<Detail {sub} />
									</Modal>
								{/if}
								<Sub {sub} {index} on:click={()=> itemModal = index} />
							{/each}
						{/key}
						{#if showSubError}
							<p in:fly={{ y: 20, delay: 500, duration: 900 }} class="mt-0">No submissions found.</p>
						{/if}
					</div>
				{/if}
				
			{/if}
		</div>
		{#if !$currentUser && show}
			{#if how}
				<How on:click={toggle} />
			{:else}
				<div in:fade={{ delay: 400 }}>
					<h2>Get started now!</h2>
					<p>Use an existing account</p>
					<div id="firebaseui-auth-container"></div>
				</div>
			{/if}
		{/if}
	</div>
</main>

{#if showAddModal}
	<BottomCard>

		{#if step == 1}
			{#if !$loadingImages && $filesToAdd.length > 0}
				<Btn on:click={()=> step ++}>Next</Btn>
			{/if}

			{#if $loadingImages && $filesToAdd.length == 0}
				<Btn lighter>
					<div class="spinner">
						<div class="bounce1"></div>
						<div class="bounce2"></div>
						<div class="bounce3"></div>
					</div>
				</Btn>
			{/if}

			{#if !$loadingImages && $filesToAdd.length == 0}
				<Btn gray>Next</Btn>
			{/if}
		{/if}

		{#if step == 2}
			{#if $userInfo.instagram && subObject.title && subObject.caption}
					<Btn on:click={()=> step ++}>Next</Btn>
			{:else}
					<Btn gray>Next</Btn>
			{/if}
		{/if}

	</BottomCard>
{/if}

<style>
	main {
		max-width: 420px;
		margin: 0 auto;
		padding: 0 1rem;
		text-align: center;
	}

	header {
		position: relative;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 3rem;
		height: 65px;
	}

	header div {
		display: flex;
		align-items: center;
		padding: .75rem 0
	}

	.logo-add {
    font-size: .8rem;
    position: absolute;
    left: 0;
    bottom: 3px;
    margin: 0;
	}

	.page-content {
    min-height: 560px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
	}

	.footer { 
    width: 100%;
	}
	.submissions {
		display: flex;
		flex-direction: column;
		gap: .5rem
	}

.spinner {
  margin: 0 auto;
  width: 40px;
  text-align: center;
}

.spinner > div {
  width: 8px;
  height: 8px;
  background-color: #171a1b;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% { 
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}

</style>